/**
 * Calculates the number of free seats available in a vehicle.
 *
 * @param {number} capacity - The total seating capacity of the vehicle.
 * @param {number} crew - The number of seats occupied by the crew.
 * @param {number} takenSeats - The number of seats already taken by passengers.
 * @returns {number} The number of free seats available in the vehicle.
 */
export const calculateVehicleFreeSeats = (capacity: number, crew: number, takenSeats: number): number => {
	return capacity - crew - takenSeats;
};
